import { Route } from '@angular/router';
import { LayoutComponent } from '@features/shopping/layout/layout.component';
import { OrderCompletionComponent } from '@features/shopping/order-completion/order-completion.component';

import { add_or_remove_features_routes } from './activity_type_routes/add-or-remove-features.routes';
import { add_service_to_existing_device_routes } from './activity_type_routes/add-service-to-existing-device.routes';
import { assign_device_routes } from './activity_type_routes/assign-device.routes';
import { assign_line_routes } from './activity_type_routes/assign-line.routes';
import { change_carrier_routes } from './activity_type_routes/change-carrier.routes';
import { change_plan_routes } from './activity_type_routes/change-plan.routes';
import { disconnect_service_routes } from './activity_type_routes/disconnect-service.routes';
import { order_accessories_routes } from './activity_type_routes/order-accessories.routes';
import { order_new_device_with_service_routes } from './activity_type_routes/order-new-device-with-service.routes';
import { order_sim_card_routes } from './activity_type_routes/order_sim_card.routes';
import { suspend_service_routes } from './activity_type_routes/suspend-service.routes';
import { transfer_liability_routes } from './activity_type_routes/transfer-liability.routes';
import { travel_request_routes } from './activity_type_routes/travel-request.routes';
import { unsuspend_service_routes } from './activity_type_routes/unsuspend-service.routes';
import { upgrade_device_routes } from './activity_type_routes/upgrade-device.routes';

export const activity_type_routes: Route[] = [
  {
    path: 'order-confirmation/:id',
    component: OrderCompletionComponent,
    title: 'Confirm your Order'
  },
  {
    path: '1',
    component: LayoutComponent,
    children: order_new_device_with_service_routes
  },
  {
    path: '2',
    component: LayoutComponent,
    children: upgrade_device_routes
  },
  {
    path: '3',
    component: LayoutComponent,
    children: add_service_to_existing_device_routes
  },
  {
    path: '4',
    component: LayoutComponent,
    children: disconnect_service_routes
  },
  {
    path: '5',
    component: LayoutComponent,
    children: change_carrier_routes
  },
  {
    path: '6',
    component: LayoutComponent,
    children: travel_request_routes
  },
  {
    path: '7',
    component: LayoutComponent,
    children: suspend_service_routes
  },
  {
    path: '8',
    component: LayoutComponent,
    children: assign_line_routes
  },
  {
    path: '9',
    component: LayoutComponent,
    children: assign_device_routes
  },
  {
    path: '10',
    component: LayoutComponent,
    children: unsuspend_service_routes
  },
  {
    path: '11',
    component: LayoutComponent,
    children: change_plan_routes
  },
  {
    path: '12',
    component: LayoutComponent,
    children: add_or_remove_features_routes
  },
  {
    path: '13',
    component: LayoutComponent,
    children: transfer_liability_routes
  },
  {
    path: '14',
    component: LayoutComponent,
    children: order_accessories_routes
  },
  {
    path: '15',
    component: LayoutComponent,
    children: order_sim_card_routes
  },
  {
    path: '1001',
    component: LayoutComponent,
    children: order_new_device_with_service_routes
  }
];
